import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class TextAnnotationView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height } = model;
    const style = model.getNodeStyle();

    const left = x - width / 2;
    const top = y - height / 2;

    // Open bracket shape "[" — top bar, left bar, bottom bar
    const bracketPath = `M ${left + 10} ${top} L ${left} ${top} L ${left} ${top + height} L ${left + 10} ${top + height}`;

    return h('g', {}, [
      // Invisible background for selection hit area
      h('rect', {
        x: left,
        y: top,
        width,
        height,
        fill: 'transparent',
        stroke: 'none',
      }),
      // Open bracket
      h('path', {
        d: bracketPath,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: style.strokeWidth,
      }),
    ]);
  }
}

class TextAnnotationModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 100;
    this.height = 40;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'textAnnotation');
    style.stroke = t.stroke || '#555';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.fill = t.fill || 'none';
    return style;
  }
}

export const TextAnnotation = {
  type: 'epx:TextAnnotation',
  view: TextAnnotationView,
  model: TextAnnotationModel,
};
